import React, {useState} from 'react'
import styled from '@emotion/styled';
// import core components
import { queryHelper } from 'helpers';
import { toDateStr } from 'utils/moment';
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Wrapper = styled.div`
    position: relative;
`;
const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9999;
    top: 0px;
    left: 0px;
    background-color: ${({theme}) => theme.colors.lightBlackOpacity};
    border-radius: ${({theme}) => theme.borderRadius.default};
`;

const Main = styled.div`
    padding: 10px;
    background: ${({theme}) => theme.colors.white};
    border: 3px solid ${({theme}) => theme.colors.blue};
    box-sizing: border-box;
    transition: ${({ theme }) => theme.transitions.cardHover};
    box-shadow: ${({theme}) => theme.shadow.card};
    border-radius: ${({theme}) => theme.borderRadius.default};
    &.inactive {
        border: 3px solid ${({theme}) => theme.colors.stroke};
        &:hover {
            transform: translateY(10px);
        }
    }
    cursor: pointer;
`;
const Header = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: 15px;
    position: relative;
    div.checkbox {
        position: absolute;
        top: -30px;
        right: -30px;
        padding: 5px;
        input {
            width: 30px;
            height: 30px;
        }
    }
    img {
        margin: 0px;
    }
`;
const StyledImage = styled.div`
    width: 70px;
    margin-right: 25px;
`;
const Content = styled.div`
    width: 100%;
    font-size: 14px;
    ul {
        margin: 0px;
        list-style-type: none;
        li {
            display: flex;
        }
    }
    p {
        font-size: 14px;
    }
    h1,
    h2,
    h3 {
        margin: 0px;
        padding: 0px;
    }
    br {
        display: block;
    }
`;
const Title = styled.h1`
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    margin: 0px;
`;
const ActionCard = props => {
    const {metaData, isSelected, handleCheck} = props;
    return (
        <Wrapper className={metaData.field_enabled === true ? "" : "hidden"}>
            {metaData.isDisabled === true && <Overlay />}
            <Main 
                className={isSelected ? "" : "inactive"}
                onClick={ev => handleCheck(metaData)}
            >
                <Header>
                    {queryHelper.getGatsbyImageData(metaData) &&
                        <StyledImage><GatsbyImage image={getImage(queryHelper.getGatsbyImageData(metaData))} alt=""/></StyledImage>
                    }
                    {queryHelper.getChildImgPublicUrl(metaData) &&
                        <img src={ queryHelper.getChildImgPublicUrl(metaData) } />
                    }
                    {metaData.field_price && 
                        <Title>
                            {metaData.field_price.formatted }<br/>{metaData.name}
                        </Title>
                    }
                    {!metaData.field_price && <Title> {metaData.name}</Title>}
                </Header>
                <Content>
                    {metaData.deliveryDate ? <div dangerouslySetInnerHTML={{ __html: `Your item will be delivered on ${toDateStr(metaData.deliveryDate)}` }}/>
                                           : metaData.description && <div dangerouslySetInnerHTML={{ __html: metaData.description.value }} />}
                </Content>
            </Main>
        </Wrapper>
    )
};

export default ActionCard;